import { IUserDto, ICharacterDto } from 'shared/interfaces';
import BaseApiService from './BaseApiService';

class UsersApiService extends BaseApiService {
    constructor() {
        super('api');
    }

    // 🔹 Получение профиля текущего пользователя
    getProfile(): Promise<IUserDto> {
        return this.GETBYID('profile', {});
    }

    // 🔹 Получение всех персонажей пользователя
    getCharacters(): Promise<ICharacterDto[]> {
        return this.GETBYID('characters/', {});
    }

    // 🔹 Получение CSV данных для персонажа по уровню
    getCharacterCSV(characterId: number, level: string): Promise<any[]> {
        return this.POST(`characters/${characterId}/csv/`, { level_name: level });
    }

    // 🔹 Получение gesture данных для персонажа
    getCharacterGesture(characterId: number, level: string): Promise<any[]> {
        return this.POST(`characters/${characterId}/gesture/`, { level_name: level });
    }

    // 🔹 Получение статистики персонажа
    getCharacterStat(characterId: number, level: string): Promise<any[]> {
        return this.POST(`characters/${characterId}/stat/`, { level_name: level });
    }
}

export default new UsersApiService();
